import {connect} from '../../app/connect';
import TemplateDeleteModal from './TemplateDeleteModal';
import {showNotificationAction, setDeleteTemplateIdAction, deleteTemplateAction} from '../../app/actions';
import {getDeleteTemplateId, getTemplateEntitiesMap} from '../../app/selectors';

const mapStateToProps = state => {
  const deleteTemplateId = getDeleteTemplateId(state);
  return {
    deleteTemplateId,
    template: getTemplateEntitiesMap(state)[deleteTemplateId]
  };
};

const mapDispatchToProps = {
  setDeleteTemplateIdAction,
  deleteTemplateAction,
  showNotificationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateDeleteModal);
